import { css } from '@emotion/core';
import { media, variables } from '@domain-group/fe-brary';
var colour = variables.colour,
  font = variables.font;
export var title = /*#__PURE__*/css("font-family:", font.headingFontFamily, ";font-size:", font.h3FontSize, ";color:", colour.neutral700, ";font-weight:", font.headingFontWeight, ";line-height:1.27;margin:40px 0 20px;text-align:left;", media('>=tablet'), "{text-align:center;}");
export var formSubmitError = /*#__PURE__*/css("padding:10px 20px;font-size:", font.smallFontSize, ";background-color:", colour.errorLight, ";margin-bottom:15px;border-radius:3px;display:table;width:100%;");
export var formSubmitErrorIcon = {
  name: "1tnv29r",
  styles: "display:table-cell;text-align:center;vertical-align:middle;padding-right:10px;"
};
export var formSubmitErrorMessage = {
  name: "2qghsv",
  styles: "display:table-cell;"
};
export var body = {
  name: "16b2ug3",
  styles: "margin:15px 0;"
};
export var bodyBold = /*#__PURE__*/css("font-weight:", font.headingFontWeight, ";");
export var footer = {
  name: "uewl2b",
  styles: "margin-bottom:20px;"
};
export var button = {
  name: "1kb26de",
  styles: "width:100%;height:40px;"
};
export var submitButton = /*#__PURE__*/css(button, " margin-bottom:14px;");
export var submitButtonLoader = {
  name: "oe4vh5",
  styles: "vertical-align:-4px;"
};